import PackageInformation from './PackageInformation';

export default PackageInformation;
